import styled, { css } from 'styled-components';
import Button from '~/components/form-elements/button';
import { CALLOUT_TYPE } from '~/constants';
import { color, spacing, media, Heading2 } from '~/theme';

export type CalloutColor =
    | 'DarkTeal'
    | 'DarkGold'
    | 'DarkYellow'
    | 'DarkTaupe'
    | 'DarkLime'
    | 'DarkSky'
    | 'DarkPurple'
    | 'DarkRed';

const getLeftBorderColor = (calloutColor?: CalloutColor) => {
    switch (calloutColor) {
        case 'DarkTeal':
            return color.palette.systemDarkTeal;
        case 'DarkGold':
            return color.palette.systemDarkGold;
        case 'DarkYellow':
            return color.palette.systemDarkYellow;
        case 'DarkTaupe':
            return color.palette.systemDarkTaupe;
        case 'DarkLime':
            return color.palette.systemDarkLime;
        case 'DarkRed':
            return color.palette.systemDarkRed;
        case 'DarkSky':
        default:
            return color.palette.systemDarkSky;
        case 'DarkPurple':
            return color.palette.systemDarkPurple;
    }
};

export const CalloutContainer = styled.div<{
    $alertType: CALLOUT_TYPE;
    $calloutColor?: CalloutColor;
}>`
    border-width: 0 0 0 0.25rem;
    border-style: solid;
    padding: ${spacing.spacing5};
    margin: ${spacing.spacing5} ${spacing.spacing0} ${spacing.spacing0};
    width: 100%;
    position: relative;
    @media (${media.small}) {
        max-width: 48rem;
    }
    border-color: ${props => getLeftBorderColor(props.$calloutColor)};

    ${props =>
        props.$alertType === CALLOUT_TYPE.CALLOUT &&
        css`
            background: ${color.palette.greyscale5};
        `};

    ${props =>
        props.$alertType === CALLOUT_TYPE.ASIDE &&
        css`
            margin-left: ${spacing.spacing6};
        `};
`;

export const CalloutHeadingContainer = styled.div<{ $dismissible?: boolean }>`
    display: flex;
    align-items: center;
    margin: ${props =>
        props.$dismissible
            ? `${spacing.spacing0} ${spacing.spacing8} ${spacing.spacing4} ${spacing.spacing0}`
            : `${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing4} ${spacing.spacing0}`};
`;

export const DismissButton = styled(Button).attrs({
    appearance: 'tertiary',
})`
    font-size: 2rem;
    line-height: 1;
    padding: 0;
    position: absolute;
    top: 22px;
    right: 16px;
    min-width: ${spacing.spacing6};
    width: auto;
    margin: ${spacing.spacing0};
`;

export const CalloutHeadingIcon = styled.div`
    display: inline-block;
    vertical-align: top;
    margin-right: calc(${spacing.spacing4} * 0.95);

    & svg {
        width: ${spacing.spacing6};
        height: ${spacing.spacing6};
    }

    @media ${media.small} {
        & svg {
            width: 36px;
            height: 36px;
        }
    }
`;

export const CalloutHeading = styled(Heading2)`
    // padding-top: calc(${spacing.spacing1} * 0.5);
    margin: ${spacing.spacing0};
`;

export const CalloutBody = styled.div`
    & p {
        margin-top: ${spacing.spacing0};

        &:last-of-type {
            margin-bottom: ${spacing.spacing2};
        }

        &:last-of-type + ul {
            margin-top: ${spacing.spacing4};
        }
    }

    & ul {
        list-style-type: disc;
        margin-left: calc(${spacing.spacing4} + ${spacing.spacing1});
        padding: ${spacing.spacing0};

        li {
            padding-bottom: ${spacing.spacing3};

            &:last-child {
                padding-bottom: ${spacing.spacing0};
            }
        }

        &:last-of-type {
            margin-bottom: ${spacing.spacing3};
        }
    }
`;

export default {
    CalloutContainer,
    CalloutHeadingContainer,
    CalloutHeadingIcon,
    CalloutBody,
};
